import {isMenuDismissed, showDevInfo} from 'components/app/Navigation/DevInfo/util';
import Loadable from 'utils/Loadable';

const AsyncDevInfoIndicator = Loadable({loader: () => import('components/app/Navigation/DevInfo/DevInfoIndicator')});

const DevInfoIndicator = ({specificApiURL}: {specificApiURL?: string}) => {
  if (!showDevInfo || isMenuDismissed()) {
    return null;
  }
  return <AsyncDevInfoIndicator specificApiURL={specificApiURL} />;
};

export default DevInfoIndicator;
